var React = require('react');

var Dialog = require('./dialog.js');

var css = require('./module.scss');
var Button = require('../button/index.js');
var closeImg = require('./images/close.png');

/**
 * 使用方法：
 * <Modal visible={this.state.modal.visible}
        title='hello'
        style={{width: '200px'}}
        footer={null}
        onOk={this.onOK}
        onCancel={this.onCancel}
         msgContent={msgContent}
         msgContent={msgContent}
         msgFileName={msgFileName}
        >
        I am Modal
    </Modal>

 * footer可定义为null，则没有底部按钮
 * onOK：确定按钮回调函数
 * onCancel：取消按钮回调函数
 */

var Modal = React.createClass({
    onMaskClick: function() {
        if (this.props.maskClosable) {
        // if (typeof this.props.maskClosable == 'undefined' || this.props.maskClosable) {
            if (this.props.onCancel) {
                this.props.onCancel();
            }
        }
    },
    render: function() {
        var cls = ['fp-modal-container', this.props.wrapClassName];
        return <Dialog
            visible={this.props.visible}
            onMaskClick={this.onMaskClick}
            style={this.props.style}
            wrapClassName={cls.join(' ')}>
            {
                contentRender({
                    title: this.props.title,
                    content: this.props.children,
                    footer: this.props.footer,
                    bodyClass: this.props.bodyClass,
                    cancelText: this.props.cancelText,
                    okText: this.props.okText,
                    onCancel: this.props.onCancel,
                    onOk: this.props.onOk,
                    footerText: this.props.footerText,
                    hideCancelBtn:this.props.hideCancelBtn,
                    msgFileName: this.props.msgFileName,
                    ifShowDownLoad: this.props.ifShowDownLoad,
                    msgContent: this.props.msgContent,
                    msgFileDownLoad: this.props.msgFileDownLoad,
                    msgTitle: this.props.msgTitle
                })
            }
        </Dialog>;
    }
});

Modal.show = function(config) {
    var cls = ['fp-modal-container', config.wrapClassName];
    var d = Dialog.show({
        visible: config.visible,
        onMaskClick: function() {
            if (typeof config.maskClosable == 'undefined' || config.maskClosable) {
                d.destroy();
                if (config.onCancel) {
                    config.onCancel();
                }
            }

        },
        style: config.style,
        wrapClassName: cls.join(' '),
        content: contentRender({
            title: config.title,
            content: config.content,
            bodyClass: config.bodyClass,
            footer: config.footer,
            cancelText: config.cancelText,
            okText: config.okText,
            msgTitle: config.msgTitle,
            msgContent: config.msgContent,
            msgFileName: config.msgFileName,
            ifShowDownLoad: config.ifShowDownLoad,
            onCancel: function() {
                d.destroy();
                if (config.onCancel) {
                    config.onCancel();
                }

            },
            onOk: function() {
                d.destroy();
                if (config.onOk) {
                    config.onOk();
                }

            },
            msgFileDownLoad: function () {
                d.destroy();
                if (config.msgFileDownLoad) {
                    config.msgFileDownLoad();
                }

            }
        })
    });

    return d;
};
Modal.confirm = function(config) {
    var d = Modal.show({
        content: <div className='fp-confirm'>
            <span className='fp-confirm-icon'></span>
            <h3 className='fp-confirm-title'>
                {config.title}
            </h3>
            <div className='fp-confirm-text'>
                {config.content}
            </div>
            <div className='fp-confirm-btn'>
                <Button
                    onClick={function() {
                        d.destroy();
                        if (config.onOk) {
                            config.onOk();
                        }

                    }}
                    size="sm"
                    style="primary"
                    noRadius={true}>
                    {config.okText || '确定'}
                </Button>
                {
                    config.hideCancelBtn ? null
                        : <Button
                            onClick={function() {
                                d.destroy();
                                if (config.onCancel) {
                                    config.onCancel();
                                }

                            }.bind(this)}
                            className='fp-modal-cancelBtn'
                            size="sm"
                            style="default"
                            noRadius={true}>
                            {config.cancelText || '取消'}
                        </Button>
                }


            </div>
        </div>,
        footer: null,
        style: config.style || { width: "400px" },
        maskClosable: config.maskClosable
    });
    return d;
};
//增加弹窗 给导出用的
Modal.confirmRecord2 = function (config) {
    var d = Modal.show({
        content: <div className='fp-confirm'>
            <div className="fp-record-title">
                <span className='fp-recordconfirm-icon'></span>
                <p>{config.title}</p>
            </div>
            <div className="fp-record-load">是否下载</div>
            <div className="fp-record-content"><a>{config.content}</a></div>

            <div className='fp-record-btn'>
            <div className='fp-record-select'>{config.select}</div>
                <Button
                    onClick={function () {

                        if(config.exportState!=""&&config.exportState){
                        d.destroy();
                        }
                        if (config.onOk) {
                            config.onOk();
                        }

                    }}
                    size="lg"
                    className="fp-record-btn-ok"
                    style="primary"
                    noRadius={true}>
                    {config.okText || '确定'}
                </Button>
                {
                    config.hideCancelBtn ? null
                        : <Button
                            onClick={function () {
                                d.destroy();
                                if (config.onCancel) {
                                    config.onCancel();
                                }

                            }.bind(this)}
                            className='fp-record-btn-cancel'
                            size="lg"
                            style="default"
                            noRadius={true}>
                            {config.cancelText || '取消'}
                        </Button>
                }
            </div>
        </div>,
        footer: null,
        style: config.style || { width: "300px" },
        maskClosable: config.maskClosable
    });
    return d;
};


//增加弹窗 给导出用的
Modal.confirmRecord = function (config) {
    var d = Modal.show({
        content: <div className='fp-confirm'>
            <div className="fp-record-title">
                <span className='fp-recordconfirm-icon'></span>
                <p>{config.title}</p>
            </div>
            <div className="fp-record-load">是否下载</div>
            <div className="fp-record-content"><a>{config.content}</a></div>

            <div className='fp-record-btn'>

                <Button
                    onClick={function () {

                        d.destroy();

                        if (config.onOk) {
                            config.onOk();
                        }

                    }}
                    size="lg"
                    className="fp-record-btn-ok"
                    style="primary"
                    noRadius={true}>
                    {config.okText || '确定'}
                </Button>
                {
                    config.hideCancelBtn ? null
                        : <Button
                            onClick={function () {
                                d.destroy();
                                if (config.onCancel) {
                                    config.onCancel();
                                }

                            }.bind(this)}
                            className='fp-record-btn-cancel'
                            size="lg"
                            style="default"
                            noRadius={true}>
                            {config.cancelText || '取消'}
                        </Button>
                }
            </div>
        </div>,
        footer: null,
        style: config.style || { width: "300px" },
        maskClosable: config.maskClosable
    });
    return d;
};

//增加弹窗 给上传用的
Modal.confirmUploadRecord = function (config) {
    var d = Modal.show({
        content: <div className='fp-confirm'>
            <div className="fp-record-title">
                <span className='fp-recordconfirm-icon'></span>
                <p>{config.title}</p>
            </div>
            <div className="fp-record-load">是否上传</div>
            <div className="fp-record-content"><a>{config.content}</a></div>

            <div className='fp-record-btn'>

                <Button
                    onClick={function () {

                        d.destroy();

                        if (config.onOk) {
                            config.onOk();
                        }

                    }}
                    size="lg"
                    className="fp-record-btn-ok"
                    style="primary"
                    noRadius={true}>
                    {config.okText || '确定'}
                </Button>
                {
                    config.hideCancelBtn ? null
                        : <Button
                            onClick={function () {
                                d.destroy();
                                if (config.onCancel) {
                                    config.onCancel();
                                }

                            }.bind(this)}
                            className='fp-record-btn-cancel'
                            size="lg"
                            style="default"
                            noRadius={true}>
                            {config.cancelText || '取消'}
                        </Button>
                }
            </div>
        </div>,
        footer: null,
        style: config.style || { width: "300px" },
        maskClosable: config.maskClosable
    });
    return d;
};

function contentRender(config) {
    return <div>
        {
            config.title ?
                <div className={'fp-modal-head'}>
                    <span>{config.title}</span>
                    <img src={closeImg} onClick={config.onCancel}/>
                </div>
                : ''
        }
        <div className={['fp-modal-body', config.bodyClass].join(' ')}>{config.content}</div>
        {
            config.msgTitle ?
                <div className='fp-modal-msgTitle'>
                    {config.msgTitle ? config.msgTitle:''}
                </div>
                :''
        }
        {
            config.msgContent ?
                <div className='fp-modal-msgContent'>
                    <pre>{config.msgContent ? config.msgContent:''}</pre>
                </div>
                :''
        }

        {
            config.msgFileName !== null && config.ifShowDownLoad ?
                <a  onClick={config.msgFileDownLoad} className='fp-modal-download'>下载附件：</a>
                : ''
        }

        {config.msgFileName !==null && config.msgFileName!==undefined ? config.msgFileName.map(item=>
                <p style={{ 'margin': '0.1em 0','margin-left': '15px','font-size':'12px'}}>{item}</p>
            )
            :''}
        {
            config.footer !== null ?
                <div className='fp-modal-foot'>
                    {config.footerText ? config.footerText : null}
                    <div className='fp-button-panel'>
                        {
                            config.okText === null ? ''
                                : <Button
                                    onClick={config.onOk}
                                    style="primary"
                                    noRadius={true}>
                                    {config.okText || '确定'}
                                </Button>
                        }
                       {
                           config.hideCancelBtn ? ''
                        :<Button
                            onClick={config.onCancel}
                            className='fp-modal-cancelBtn'
                            style="default"
                            noRadius={true}>
                            {config.cancelText || '取消'}
                        </Button>
                       }
                    </div>
                </div>
                : ''
        }
    </div>;
}


module.exports = Modal;



// WEBPACK FOOTER //
// ./component/dialog/modal.js